<!--
 * @Description: 
 * @Author: Ingyi
 * @Date: 2021-09-02 00:12:30
 * @LastEditors: Ingyi
 * @LastEditTime: 2021-09-02 00:50:17
-->
<template>
  <div class="SupplyDetail">
    <search-header />

    <div class="supply-content">
        <div class="supply-content-left">
        <img :src=" data.imgId" />
      </div>
      <div class="supply-content-right">
        <div class="title" style="font-weight:800">{{ data.title }}</div>
     
        <div class="content-row">
      
          <div class="label" >
            联系人:
          </div>
          <div class="data">{{ this.isxian?data.contact:'登录后获取' }}</div>
        </div>
        <div class="content-row">
  
          <div class="label">
           联系电话:
          </div>
          <div class="data">{{this.isxian?data.phone:'登录后获取'  }}</div>
        </div>
         <div class="sub-title">
          <span
            >发布时间：{{ data.createTime }}</span
          >
        </div>
          <a-popconfirm title="请确认是否购买?" @confirm="() => orderAdd(data.isPay)"  okText="确定" cancelText="取消">
                <a-button class="buy-btn" type="primary">{{
                  data.isPay == 0 ? "立即购买" : "交易中"
                }}</a-button>
        </a-popconfirm>
        <!-- 购买 -->
      
      </div>
    </div>
    <div class="content-detail">
      <!--<p class="title_top">
        <span class="line"></span>
        <span class="step_title">项目基本信息</span>
      </p>
       
      <div class="row">
        <div class="step_one_left">
          <ul class="info_ul_one">
            <li>项目名称：{{data.title}}</li>
            <li>所属行业：{{data.industryCode}}</li>
          </ul>
        </div>
        <div class="step_one_right">
          <ul class="info_ul_two">
             <li>交易方式：{{data.mode}}</li>
            <li>成熟度：{{data.maturity}}</li>
          </ul>
        </div>
      </div> -->
      <!--  -->

      <p class="title_top">
        <span class="line"></span>
        <span class="step_title">描述</span>
      </p>
      <div v-html="data.remark" style="padding: 20px">
        <!-- <a-descriptions title="专利" layout="vertical" bordered>
          <a-descriptions-item label="Product"> Cloud Database </a-descriptions-item>
          <a-descriptions-item label="Billing Mode"> Prepaid </a-descriptions-item>
          <a-descriptions-item label="Automatic Renewal"> YES </a-descriptions-item>
        </a-descriptions> -->
      </div>

    
    </div>
  </div>
</template>
<script>

import  qs from 'qs'

import request from '../util/request';
export default {
  
  name: "supplyDetail",
  data() {
    return {
      isxian:false,
        data:{},
        paraId:"",
    };
  },
  mounted() {
     let id=this.$route.query.id;
     this.paraId = id;
     console.log(id);
    this.quertDetail(id);
     const userInfo = localStorage.getItem("userInfo");
      
    if (userInfo) {
        this.isxian = true;
    }
   },
   methods:{
       orderAdd(){
           let token = localStorage.getItem("token")
       console.log(token)
       if(token==null){
         this.$router.push({path:"/login",query:{url:location.hash}})
       }else{ 
            request({
                url:"/api/client/common/order",
                method:"post",
                  data: qs.stringify({id:this.paraId,type:'XQ_TYPE'}),
                headers:{
                    "Content-Type": 'application/x-www-form-urlencoded'
                }
            }).then((res)=>{
                if(res.code=='200'){
                    this.$message.success('下单成功');
                     this.$router.push({path:"/demand"})
                }else{
                    this.$message.warning(res.msg)
                }
            })
            }
       },
       quertDetail(id){
           request({
               url:"/api/client/common/demand/"+id,
               method:"get"
           }).then((res)=>{
              if (res.code == "200") {
                 this.data = res.data;
              }
           })
       }
   }
};
</script>
<style lang="less" scoped>
.supply-content {
  width: 1280px;
  background: #fff;
  margin: 20px auto;
  display: flex;
  .supply-content-left {
    width: 390px;
    img {
      margin: 20px;
      width: 350px;
      height: 350px;
      object-fit: contain;
    }
  }
  .supply-content-right {
    padding: 20px 0;
    flex: 1;
    .title {
      height: 60px;
      line-height: 30px;
      vertical-align: middle;
      font-size: 20px;
      color: #222;
    }
    .sub-title {
      text-align: left;
      vertical-align: middle;
      height: 40px;
      line-height: 40px;
      color: #888;
      font-size: 14px;
    }
    .content-row {
      display: flex;
      align-items: center;
      height: 40px;
      .label {
        color: #9b9b9b;
      }
      .data {
        color: #666;
      }
    }
    .buy-btn {
      margin: 40px;
      font-size: 16px;
    }
  }
}
.content-detail {
  width: 1280px;
  background: #fff;
  margin: 0 auto;
  .title_top {
    width: 100%;
    height: 34px;
    text-align: left;
    background: #e9f0f8;
    .line {
      height: 16px;
      line-height: 34px;
      display: inline-block;
      vertical-align: middle;
      margin-left: 15px;
      border-left: 4px solid #4790ff;
    }
    .step_title {
      font-size: 18px;
      color: #333;
      font-weight: 700;
      text-align: left;
      line-height: 34px;
      margin-left: 10px;
      display: inline-block;
      vertical-align: middle;
    }
  }
  .row {
    display: flex;
    ul > li {
      line-height: 40px;
      font-size: 15px;
      color: #666;
    }
    div {
      flex: 1;
    }
  }
}
ul {
  list-style: none;
}
</style>
